import React from "react";

type Props = {
  children: React.ReactNode;
  breadcrumb?: React.ReactNode;
  panel?: React.ReactNode;
  bgColor?: string;
};

export function Content(props: Props) {
  return (
    <div className="content-w" style={{ backgroundColor: props?.bgColor }}>
      {props.breadcrumb}
      <div className="content-i">
        <div className="content-box" id="content" style={{ padding: "1rem 1.5rem" }}>
          {props.children}
        </div>
        {props.panel}
      </div>
    </div>
  );
}
